import api from '@/api/blog'
import {
  BLOG_SET_POSTS,
  BLOG_SET_PHOTOS,
  BLOG_SET_VIDEOS,
  BLOG_SET_POST,
  BLOG_SET_VIDEO,
  BLOG_SET_ABOUT_PRIEST,
  BLOG_ADD_COMMENT_POST,
  BLOG_ADD_COMMENT_PHOTO,
  BLOG_ADD_COMMENT_VIDEO,
  BLOG_SET_COMMENT_POST,
  BLOG_SET_COMMENT_PHOTO,
  BLOG_SET_COMMENT_VIDEO,
  BLOG_VOTE_POST,
  BLOG_VOTE_PHOTO,
  BLOG_VOTE_VIDEO,
  BLOG_SET_CATALOG,
  BLOG_SET_FILE,
  BLOG_SET_CATALOGS,
  BLOG_SET_FILES,
  BLOG_LIB_CATALOG_OPEN,
  BLOG_LIB_CATALOG_CLOSE,
  BLOG_DELETE_PHOTO, BLOG_DELETE_VIDEO
} from './mutations'

export default {
  async loadAboutPriest ({ commit, rootState }, priest) {
    const { info } = await api.loadAboutPriest(priest)
    commit(BLOG_SET_ABOUT_PRIEST, { parish: rootState.ParishModule.current, info })
  },
  async loadLastPosts ({ commit }, parish) {
    const { posts } = await api.loadPosts(parish)
    commit(BLOG_SET_POSTS, { parish, posts })
  },
  async loadLastPhotos ({ commit }, parish) {
    const { photos } = await api.loadPhotos(parish)
    commit(BLOG_SET_PHOTOS, { parish, photos })
  },
  async loadLastVideos ({ commit }, parish) {
    const { videos } = await api.loadVideos(parish)
    commit(BLOG_SET_VIDEOS, { parish, videos })
  },
  async loadLibrary ({ commit }, parish) {
    const { catalogs, files } = await api.loadLibrary(parish)
    commit(BLOG_SET_CATALOGS, { parish, catalogs })
    commit(BLOG_SET_FILES, { parish, files })
  },
  async loadPost ({ commit }, { parish, post }) {
    const result = await api.loadPost(parish, post)
    commit(BLOG_SET_POST, { parish, post: result.post })
  },
  async loadVideo ({ commit }, { parish, video }) {
    const result = await api.loadVideo(parish, video)
    commit(BLOG_SET_VIDEO, { parish, video: result.video })
  },
  async savePost ({ commit }, { parish, post }) {
    const result = await api.savePost(parish, post)
    commit(BLOG_SET_POST, { parish, post: result.post })
  },
  async savePhoto ({ commit }, { parish, images }) {
    const { photos } = await api.savePhoto(parish, images)
    commit(BLOG_SET_PHOTOS, { parish, photos })
  },
  async saveVideo ({ commit }, { parish, video }) {
    const result = await api.saveVideo(parish, video)
    commit(BLOG_SET_VIDEO, { parish, video: result.video })
  },
  async deletePhoto ({ commit }, { parish, photo }) {
    const { message } = await api.deletePhoto(parish, photo)
    commit(BLOG_DELETE_PHOTO, { parish, photo })
    return message
  },
  async deleteVideo ({ commit }, { parish, video }) {
    const { message } = await api.deleteVideo(parish, video)
    commit(BLOG_DELETE_VIDEO, { parish, video })
    return message
  },
  async saveCatalog ({ commit }, { parish, catalog }) {
    const result = await api.saveCatalog(parish, catalog)
    commit(BLOG_SET_CATALOG, { parish, catalog: result.catalog })
  },
  async saveFile ({ commit }, { parish, file }) {
    const result = await api.saveFile(parish, file)
    commit(BLOG_SET_FILE, { parish, file: result.file })
  },
  async sendCommentForPost ({ commit, rootState }, { post, message, parent }) {
    const { comment } = await api.sendCommentForPost(rootState.ParishModule.current, post, { message, parent: parent ? parent.id : null })
    commit(BLOG_ADD_COMMENT_POST, { parish: rootState.ParishModule.current, post, comment })
  },
  async sendCommentForPhoto ({ commit, rootState }, { photo, message, parent }) {
    const { comment } = await api.sendCommentForPhoto(rootState.ParishModule.current, photo, { message, parent: parent ? parent.id : null })
    commit(BLOG_ADD_COMMENT_PHOTO, { parish: rootState.ParishModule.current, photo, comment })
  },
  async sendCommentForVideo ({ commit, rootState }, { video, message, parent }) {
    const { comment } = await api.sendCommentForVideo(rootState.ParishModule.current, video, { message, parent: parent ? parent.id : null })
    commit(BLOG_ADD_COMMENT_VIDEO, { parish: rootState.ParishModule.current, video, comment })
  },
  async deleteComment ({ commit, rootState }, comment) {
    const result = await api.deleteComment(rootState.ParishModule.current, comment)
    switch (comment.object.type) {
      case 'post':
        commit(BLOG_SET_COMMENT_POST, { parish: rootState.ParishModule.current, post: comment.object, comment: result.comment })
        break
      case 'PHOTO':
        commit(BLOG_SET_COMMENT_PHOTO, { parish: rootState.ParishModule.current, photo: comment.object, comment: result.comment })
        break
      case 'video':
        commit(BLOG_SET_COMMENT_VIDEO, { parish: rootState.ParishModule.current, video: comment.object, comment: result.comment })
        break
    }
  },
  async votePost ({ commit }, { parish, post }) {
    const { vote } = await api.votePost(parish, post)
    if (vote) {
      commit(BLOG_VOTE_POST, { parish, post, vote })
    }
  },
  async votePhoto ({ commit }, { parish, photo }) {
    const { vote } = await api.votePhoto(parish, photo)
    if (vote) {
      commit(BLOG_VOTE_PHOTO, { parish, photo, vote })
    }
  },
  async voteVideo ({ commit }, { parish, video }) {
    const { vote } = await api.voteVideo(parish, video)
    if (vote) {
      commit(BLOG_VOTE_VIDEO, { parish, video, vote })
    }
  },

  openCatalog ({ commit }, { parish, catalog }) {
    commit(BLOG_LIB_CATALOG_OPEN, { parish, catalog })
  },
  closeCatalog ({ commit }, { parish, catalog }) {
    commit(BLOG_LIB_CATALOG_CLOSE, { parish, catalog })
  },

  async removeLibraryItem ({ commit }, { parish, item }) {
    await api.removeLibraryItem(parish, item)
    const { catalogs, files } = await api.loadLibrary(parish)
    commit(BLOG_SET_CATALOGS, { parish, catalogs })
    commit(BLOG_SET_FILES, { parish, files })
  }
}
